
export default function ErrorBlock({ text, onReload, reloadButtonText = undefined }) {
    return <div className="text-center">
        <div className="mb-4">
            {text}
        </div>
        {onReload && <a role="button" className="button button-base" onClick={() => onReload()}>{reloadButtonText || __('common.reloadButton.text')}</a>}
    </div>
}
